import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import './filterColumn.css';

// ── TextField sx ──────────────────────────────────────────────────────────────

export const textFieldSx = (theme: Theme) => ({
  maxWidth: 140,
  '& .MuiInputBase-root': {
    height: 'var(--filter-height)',
    fontSize: 'var(--filter-font-size)',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 'var(--filter-border-radius)',
    color: theme.palette.common.black,
  },
  '& .MuiInputBase-input': {
    py: 0,
    px: 0.75,
    '&::placeholder': {
      color: alpha(theme.palette.common.black, 0.65),
      opacity: 1,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.divider,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&:focus-within .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1px !important',
  },
});

// ── Select sx ─────────────────────────────────────────────────────────────────

export const selectSx = (theme: Theme) => ({
  height: 'var(--filter-height)',
  fontSize: 'var(--filter-font-size)',
  backgroundColor: theme.palette.background.paper,
  borderRadius: 'var(--filter-border-radius)',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.divider,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1px !important',
  },
  '& .MuiSelect-select': {
    py: 0,
    px: 1,
    fontSize: 'var(--filter-font-size)',
    color: theme.palette.common.black,
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.action.active,
    fontSize: theme.typography.body1.fontSize,
  },
});

// ── Dropdown menu sx ──────────────────────────────────────────────────────────

export const menuPaperSx = (theme: Theme) => ({
  '& .MuiMenuItem-root': {
    fontSize: 'var(--filter-font-size)',
    color: theme.palette.common.black,
    textAlign: 'left',
  },
  '& .MuiMenuItem-root.Mui-selected': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  '& .MuiMenuItem-root.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
  },
});

export const menuItemSx = (theme: Theme) => ({
  fontSize: 'var(--filter-font-size)',
  color: theme.palette.common.black,
  textAlign: 'left' as const,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  '&.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
  },
});
